import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthService } from './auth.service';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
	providedIn: 'root',
})
export class ApiService {
	// url for live server backend
	url: string = 'https://itaxapi.hostbooks.com/hbtax-0.1';

	// url: string = 'https://taxbackend.hostbooks.in/hbtax-0.1';
	// url for sandbox server backend from target

	//livein
	// public ssoAuthURL: String = 'https://5o32w6kkla.execute-api.us-west-1.amazonaws.com/dev';
	// // public ssoCommonURL: String = 'https://cp1api.hostbooks.com/dev';
	// public ssoCommonURL: String = 'https://8489dha12c.execute-api.ap-south-1.amazonaws.com/dev';
	// public auth_x_api_key = 'rnEzMTQ1Ki9hlN265DERl4TLdUzQwsN35i1Odrw4';
	// public common_x_api_key = 'XnKHOKxsaq10ZRz88Uo5w48QjDxsSq5VgNna7itf';


	//  url: string = 'http://localhost:8080';


	

	
	//live
	public ssoAuthURL: String = 'https://ssoapi.hostbooks.com';
	// public ssoCommonURL: String = 'https://cp1api.hostbooks.com/dev';
	public ssoCommonURL: String = 'https://inapi.hostbooks.com';
	public auth_x_api_key = 'rnEzMTQ1Ki9hlN265DERl4TLdUzQwsN35i1Odrw4';
	public common_x_api_key = 'XnKHOKxsaq10ZRz88Uo5w48QjDxsSq5VgNna7itf';
	// Sandbox Customer Portal keys/
	// public ssoAuthURL: String = 'https://329pftjdd4.execute-api.us-west-1.amazonaws.com/testing';
	// // //public ssoCommonURL: String = this.url+'/sso/common';
	// public ssoCommonURL: String = 'https://inapi.hostbooks.in';
	// public auth_x_api_key = 'gRhJPl8Avv5VjA8lWTxxK2hzqbfcr37TmhKXrAEa';
	// public common_x_api_key = 'FjrJo2TNUz94k6LQKs5h31lcVxPMybMG1D2O3ben';



	// Customer portal client key always remain same
	public client_id = 'fHDykLmdkYPkbKnWbWPzsZduNtEIOWEQoHWBvX';
	public client_secret = 'IRzyueEriczbrlOkHDphhGgJysykbaLRoi';
	public http_x_auth = null;
	// //Url of customer portal sandbox
	// public ssoLoginURL = 'https://in.hostbooks.in/cp1/testing/index.php/user/dashboard';

	//	Url of customer portal live
	 public ssoLoginURL = 'https://sso.hostbooks.com/';

	headers: any;

	constructor(private http: HttpClient, private cookieService: CookieService, public auth: AuthService) {
		this.auth.ssoLoginURL = this.ssoLoginURL;
		this.headers = new HttpHeaders({
			'Content-Type': 'application/json',
			'Access-Control-Allow-Origin': '*',
		});
	}

	cleanPreserveKey() {
		this.cookieService.deleteAll();
		console.log('Preserve Key cleaned');
	}

	ssoAuth(endpoint: string, body: any) {
		const header = {
			headers: new HttpHeaders({
				'Content-Type': 'application/json',
			}),
		};
		return this.http.post(this.url + '/' + endpoint, body, header);
	}
	

	ssoCommon(endpoint: string, body: any) {
		const header = {
			headers: new HttpHeaders({
				'Content-Type': 'application/json',
				'client-id': this.client_id,
				'client-secret': this.client_secret,
				'x-api-key': this.common_x_api_key,
				//'http-x-auth': this.http_x_auth, 
				'x-auth': this.http_x_auth, // need to change if don't work 
			}),
		};
		return this.http.post(this.ssoCommonURL + '/' + endpoint, body, header);
	}

	login(endPoint: any) {
		const headerOptions = {
			headers: new HttpHeaders({
				'Content-Type': 'application/json',
			}),
		};
		return this.http.get(this.url + '/' + endPoint, headerOptions);
	}

	post(endPoint: any, body: any) {
		const httpOptions = {
			headers: new HttpHeaders({
				'Content-Type': 'application/json',
				token: this.auth.token,
			}),
		};
		return this.http.post(this.url + '/' + endPoint, body, httpOptions);
	}

	postAsync(endPoint: String, body: any) {
		const httpOptions = {
			headers: new HttpHeaders({
				'Content-Type': 'application/json',
				token: this.auth.token,
			}),
		};

		return new Promise((resolve, reject) => {
			this.http.post(this.url + '/' + endPoint, body, httpOptions).subscribe(
				res => {
					resolve(res);
				},
				err => {
					reject(err);
				}
			);
		});
	}

	postdownloadpdf(endPoint: any, file: any) {
		var body = { filename: file };
		const httpOptions = {
			headers: new HttpHeaders({
				'Content-Type': 'application/json',
				token: this.auth.token,
			}),
			responseType: 'blob',
		};
		return this.http.post(this.url + '/' + endPoint, body, {
			responseType: 'blob',
			headers: new HttpHeaders().append('Content-Type', 'application/json').append('token', this.auth.token),
		});
	}

	getAsync(endPoint: String) {
		const httpOptions = {
			headers: new HttpHeaders({
				'Content-Type': 'application/json',
				token: this.auth.token,
			}),
		};

		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/' + endPoint, httpOptions).subscribe(
				res => {
					resolve(res);
				},
				err => {
					reject(err);
				}
			);
		});
	}

	get(endPoint: any) {
		const httpOptions = {
			headers: new HttpHeaders({
				'Content-Type': 'application/json',
				token: this.auth.token,
			}),
		};
		return this.http.get(this.url + '/' + endPoint, httpOptions);
	}

	delete(endPoint: any) {
		const httpOptions = {
			headers: new HttpHeaders({
				'Content-Type': 'application/json',
				token: this.auth.token,
			}),
		};
		return this.http.delete(this.url + '/' + endPoint, httpOptions);
	}

	put(endPoint: any, body: any) {
		const httpOptions = {
			headers: new HttpHeaders({
				'Content-Type': 'application/json',
				token: this.auth.token,
			}),
		};
		return this.http.put(this.url + '/' + endPoint, body, httpOptions);
	}

	postDownloadPdf(endPoint: any, file: any) {
		const body = { filename: file };
		const httpOptions = {
			headers: new HttpHeaders({
				'Content-Type': 'application/json',
				token: this.auth.token,
			}),
			responseType: 'blob',
		};
		return this.http.post(this.url + '/' + endPoint, body, {
			responseType: 'blob',
			headers: new HttpHeaders().append('Content-Type', 'application/json').append('token', this.auth.token),
		});
	}

	printPDF(url: any, body: any) {
		const httpOptions = {
			headers: new HttpHeaders({
				'Content-Type': 'application/json',
			}),
		};
		return this.http.post(url, body, httpOptions);
	}

	//---//

	apiGet(endPoint: any) {
		const httpOptions = {
			headers: new HttpHeaders({
				'Content-Type': 'application/json',
				token: this.auth.token,
			}),
		};
		return this.http.get(this.url + '/' + endPoint, httpOptions);
	}

	commonEnd(endpoint: string, body: any) {
		const header = {
			headers: new HttpHeaders({
				'Content-Type': 'application/json',
				'client-id': this.client_id,
				'client-secret': this.client_secret,
				'x-api-key': this.common_x_api_key,
				//'http-x-auth': this.http_x_auth, 
				'x-auth': this.http_x_auth, // need to change if don't work 
			}),
		};
		return this.http.post(this.ssoCommonURL + '/' + endpoint, body, header);
	}
}
